"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  writeAnnouncement: 'Написать объявление',
  creatingComplaint: 'Пожаловаться/создать новое обращение',
  book: 'Забронировать'
};